import { DataSourceName } from "../../utils/dictionary";
import "./DataSource.css";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import { GoCpu } from "react-icons/go";

export function DataSource(props) {
	return (
		<div className="data-source-chip">
			{props.source === 1 ? (
				<GoCpu size={17} />
			) : (
				<HiOutlineGlobeAlt size={17} />
			)}
			<span>{DataSourceName[props.source]}</span>
		</div>
	)
}